import { FC } from 'react'
import { Icon, IconColor } from '@/dc-shared-web/src'
import clsx from 'clsx'
import { getFileIconByExtension } from '@/app/(dashboard)/upload/utils/getFileIconByExtension'

export type SelectedFileProps = {
  /** File to display. */
  file: File
}

export const SelectedFile: FC<SelectedFileProps> = ({ file }) => {
  const icon = getFileIconByExtension(file)

  return (
    <div className={clsx('tw-flex tw-items-center tw-gap-4')}>
      <Icon icon={icon} color={IconColor.tertiary} size='2xl' />
      <p className='tw-flex-1 tw-text-sm tw-text-gray-900 tw-break-all'>
        {file.name}
      </p>
    </div>
  )
}
